import {createSlice} from "@reduxjs/toolkit";

export const cartSlice = createSlice({
    name: "cartList",
    initialState: {
        value: [],
    },
    reducers: {
        setContent: (state, action) => {
            state.value = action.payload;
        },
        addItem: (state, action) => {
            const itemToAdd = action.payload;
            state.value.push(itemToAdd);
        },
        removeItemByIdx: (state, action) => {
            const indexToRemove = action.payload;
            if (indexToRemove >= 0 && indexToRemove < state.value.length) {
                state.value.splice(indexToRemove, 1);
            }
        },
        updateItemByIdx: (state, action) => {
            const {index, newObject} = action.payload;
            if (index >= 0 && index < state.value.length) {
                state.value[index] = newObject;
            }
        },
    },
});

export const {
    setContent,
    addItem,
    removeItemByIdx,
    updateItemByIdx
} = cartSlice.actions;

export default cartSlice.reducer;


